import { SUBSCRIPTION_TIER_IDS } from '../constants/subscriptionTiers';
import {
  PLUS_MEMBER_FEE_COPY,
  WALLET_SUBSCRIPTION_SEPARATION,
} from '../constants/productCopy';
import { hasLockedInPlus } from './platformFee';

/** @deprecated alias of hasLockedInPlus — kept for call-site compatibility. */
export function hasActiveSubscription(profile) {
  return hasLockedInPlus(profile);
}

/** @deprecated use hasLockedInPlus from platformFee */
export function isFreeUser(profile) {
  return !hasLockedInPlus(profile);
}

export function isTrialing(profile) {
  return profile?.subscriptionStatus === 'trialing';
}

export function getSubscriptionTier(profile) {
  if (!hasActiveSubscription(profile)) return null;
  return SUBSCRIPTION_TIER_IDS.PLUS;
}

export function getTrialEndDate(profile) {
  const ts = Number(profile?.trialEndDate);
  return Number.isFinite(ts) && ts > 0 ? ts * 1000 : null;
}

export function getSubscriptionEndDate(profile) {
  const ts = Number(profile?.subscriptionEndDate || profile?.subscriptionCurrentPeriodEnd);
  return Number.isFinite(ts) && ts > 0 ? ts * 1000 : null;
}

export function formatSubscriptionDate(ms) {
  if (!ms) return null;
  return new Date(ms).toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}

/** All premium features require LockedIn Plus (active or trialing subscription). */
export function hasLiveSubscriptionAccess(profile) {
  return hasLockedInPlus(profile);
}

export function canUsePrivateChat(profile) {
  return hasLockedInPlus(profile);
}

export function canAddFriendsUnlimited(profile) {
  return hasLockedInPlus(profile);
}

export function canSeeScoreStreaks(profile) {
  return hasLockedInPlus(profile);
}

export function canUseCustomWagers(profile) {
  return hasLockedInPlus(profile);
}

export const SUBSCRIPTION_REQUIRED_MESSAGE =
  'LockedIn Plus unlocks premium features and a 2% platform fee. Subscription payments do not add wallet funds.';

export const LIVE_SUBSCRIPTION_LOCKED_MESSAGE =
  'Upgrade to LockedIn Plus in Wallet for premium features and a reduced platform fee.';

export const PLUS_FEE_MESSAGE = PLUS_MEMBER_FEE_COPY;

export const WALLET_SUBSCRIPTION_SEPARATION_MESSAGE = WALLET_SUBSCRIPTION_SEPARATION;
